import React, { useState } from "react";
import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { ChecklistForm } from "./ChecklistForm";
import { logError } from "../../../utils/appUtils";

const CreateActions = (props) => {
  return (
    <TopToolbar>
      <BackButton {...props} />
    </TopToolbar>
  );
};

const CreateToolbar = (props) => (
  <Toolbar {...props}>
    <ValidateSaveButton {...props} />
  </Toolbar>
);

export const validateChecklist = (record) => {
  const errors = {};
  if (!record.checklistItems || record.checklistItems.length === 0) {
    errors.checklistItems =
      "A checklist must contain at least one checklist item.";
  }
  if (!record.resourceId) errors.resourceId = "Invalid resource.";
  return errors;
};

export const ChecklistCreate = (props) => {
  const { history } = props;
  const backPath = getBackPath(props);

  const initValues = {
    active: true,
    groups: window.appUser.reloadYard.groups,
    reloadYardId: window.appUser.reloadYardId,
    resourceId: props.location.state.resourceId,
    createdBy: window.appUser.email,
    processName: "Inbound Shipment",
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Checklist" />}
      actions={<CreateActions backPath={backPath} history={history} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        initialValues={initValues}
        validate={validateChecklist}
        toolbar={
          <CreateToolbar {...props} backPath={backPath} history={history} />
        }
      >
        <ChecklistForm {...props} />
      </SimpleForm>
    </Create>
  );
};

export const ValidateSaveButton = (props) => {
  const notify = useNotify();
  const [saving, setSaving] = useState(false);
  const { backPath, history } = props;

  const onSuccess = async ({ data }) => {
    notify(`Checklist created successfully.`);
    setSaving(false);
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setSaving(false);
    logError(
      "checklists:ChecklistCreate:ValidateSaveButton:onFailure",
      error,
      notify
    );
  };

  return (
    <SaveButton
      label="Save"
      disabled={saving}
      submitOnEnter={false}
      undoable={false}
      onSuccess={onSuccess}
      onFailure={onFailure}
      {...props}
    />
  );
};
